<nav class="sidenav-container" appUserManual [userManualKey]="'side-navigation'">
  <div class="main-menu-container" [class.expanded]="isOpen">
    @if (isOpen) {
      <div>
        <div class="project-selector">
          @if (isOnline) {
            <app-project-selector></app-project-selector>
          }
        </div>
        @if (displayTaskFilter) {
          <app-task-selector></app-task-selector>
        }
        @if (displaySiteFilter) {
          <app-site-selector></app-site-selector>
        }
        <div class="tree-container">
          <app-tree></app-tree>
        </div>
        <div class="download-scope-container">
          @if (isOnline && displayReports) {
            <div class="download-scope">
              <button class="menu-button aker-context-button sidenav-full-button" mat-raised-button (click)="loadReports()">
                <mat-icon>stacked_line_chart</mat-icon><span>Reports</span>
              </button>
            </div>
          }
          @if (isOnline && hasAccessToSupplierModule) {
            <div class="download-scope">
              <button class="menu-button aker-context-button sidenav-full-button" mat-raised-button (click)="loadSupplierModule()">
                <mat-icon>forklift</mat-icon><span>Supplier</span>
              </button>
            </div>
          }
          @if (isOnline && hasAccessToBatchModule) {
            <div class="download-scope">
              <button class="menu-button aker-context-button sidenav-full-button" mat-raised-button (click)="loadBatchModule()">
                <mat-icon>batch_prediction</mat-icon><span>Batch Update</span>
              </button>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="project-selector">
        <a
          title="Select project"
          class="menu-item"
          (click)="toggleOpen()"
          aria-label="Dashboard"
          cdkMonitorElementFocus
          [routerLink]="['', 'dashboard']"
        >
          <i class="material-icons menu-item-icon">dashboard</i>
        </a>
      </div>
      <a title="Expand tree" (click)="toggleOpen(); loadDashboard()" class="menu-item" tabindex="0" cdkMonitorElementFocus>
        <i class="material-icons menu-item-icon">tune</i>
      </a>
      @if (isOnline) {
        <a title="Offline downloads" (click)="toggleOpen(); loadDownloads()" class="menu-item" tabindex="0" cdkMonitorElementFocus>
          <img
            class="material-icons menu-item-icon download-scope-icon"
            draggable="false"
            src="assets/icon/Download-White.svg"
            alt="Download"
          />
        </a>
      }
      @if (isOnline) {
        <a title="Reports" (click)="toggleOpen(); loadReports()" class="menu-item" tabindex="0" cdkMonitorElementFocus>
          <i class="material-icons menu-item-icon">stacked_line_chart</i>
        </a>
      }
      @if (isOnline) {
        <a title="Reports" (click)="toggleOpen(); loadSupplierModule()" class="menu-item" tabindex="0" cdkMonitorElementFocus>
          <i class="material-icons menu-item-icon">forklift</i>
        </a>
      }
    }
    <div class="footer">
      <button title="Expand menu" class="expand-button" cdkMonitorElementFocus (click)="toggleOpen()" [class.flipped]="isOpen">
        <i class="material-icons">arrow_forward</i>
      </button>
    </div>
  </div>
</nav>
